<template>
  <v-navigation-drawer
    class="drawer"
    right
    fixed
    clipped
    permanent
    app
    width="354"
    overlay-color="transparent"
    :key="navbar_rerender"
  >

    <!-- Menu sem selecionar seção  -->
    <section v-if="!navbar.sectionId" class="pt-3 pb-8">

      <menu-section v-model="isExpanded.styles" label="Estilos" @add="handleAddStyle">
        <MenuStyles/>
      </menu-section>

      <menu-section v-model="isExpanded.pages" label="Páginas" @add="handleAddPage">
        <MenuPages ref="menuPages"/>
      </menu-section>

      <menu-section v-model="isExpanded.sections" label="Seções" @add="handleAddSection">
        <MenuOptions :types="types" :handleCloseSection="handleCloseSection" />
      </menu-section>

      <menu-section v-model="isExpanded.config" label="Configurações" :add-btn="false">
        <FormOthers />
      </menu-section>

      <menu-section v-model="isExpanded.integrations" label="Integrações" :divider="false" :add-btn="false">
        <FormIntegrations :integrations="infos.integrations" />
      </menu-section>
    </section>

    <!-- Ao selecionar alguma seção  -->
    <section v-else class="pt-5 pb-8 px-5">
      <CurrentSection :selectedSection="selectedSection" :types="types" :handleCloseSection="handleCloseSection"/>

      <SelectStyle v-if="selectedSection.type !== 'style-config'" :types="types" :selectedSection="selectedSection" />

      <FormLayout 
        v-if="selectedSection.type === 'style-config'" 
        :layout="infos.layout" 
        @cancelNewStyle="handleCancelNewStyle" 
        @onCreateNewStyle="onCreateNewStyle"
      />

      <AppBarSection v-if="selectedSection.type === 'menu'" :selectedSection="selectedSection" :sectionsId="sectionsId"/>

      <CoverSection v-if="selectedSection.type === 'cover'" :selectedSection="selectedSection" :sectionsId="sectionsId"/>

      <ContentSection v-if="selectedSection.type === 'content'" :selectedSection="selectedSection" :sectionsId="sectionsId"/>

      <TicketsSection v-if="selectedSection.type === 'tickets'" :selectedSection="selectedSection" :sectionsId="sectionsId"/>

      <ContactSection v-if="selectedSection.type === 'contact'" :selectedSection="selectedSection" :sectionsId="sectionsId"/>

      <CrmSection v-if="selectedSection.type === 'crm'" :selectedSection="selectedSection" :sectionsId="sectionsId"/>

      <FooterSection v-if="selectedSection.type === 'footer'" :selectedSection="selectedSection" :sectionsId="sectionsId"/>

      <NumbersSection v-if="selectedSection.type === 'numbers'" :selectedSection="selectedSection" :sectionsId="sectionsId"/>

      <CampaignSection v-if="selectedSection.type === 'campaign'" :selectedSection="selectedSection" :sectionsId="sectionsId"/>

      <GallerySection v-if="selectedSection.type === 'gallery'" :selectedSection="selectedSection" :sectionsId="sectionsId"/>

      <SpeakersSection v-if="selectedSection.type === 'speakers'" :selectedSection="selectedSection" :sectionsId="sectionsId"/>

      <LogosSection v-if="selectedSection.type === 'logos'" :selectedSection="selectedSection" :sectionsId="sectionsId"/>

      <SponsorsSection v-if="selectedSection.type === 'sponsors'" :selectedSection="selectedSection" :sectionsId="sectionsId"/>

      <ScheduleSection v-if="selectedSection.type === 'schedule'" :selectedSection="selectedSection" :sectionsId="sectionsId"/>
      
      <PersonalizedFaqSection v-if="selectedSection.type === 'personalizedFaq'" :selectedSection="selectedSection" :sectionsId="sectionsId"/>

      <TestimonialsSection v-if="selectedSection.type === 'testimonials'" :selectedSection="selectedSection" :sectionsId="sectionsId"/>

      <MaterialsSection v-if="selectedSection.type === 'materials'" :selectedSection="selectedSection" :sectionsId="sectionsId"/>
    </section>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex"
import { generateId } from '../../helpers/generateId'
import { createUsingSchema } from '../../schemas'
import { LAYOUT_SCHEMA } from '../../schemas/layout/schema'
import MenuStyles from './common/MenuStyles'
import MenuPages from './common/MenuPages'
import MenuSection from './common/MenuSection'
import MenuOptions from './common/MenuOptions'
import CurrentSection from './common/CurrentSection.vue'
import SelectStyle from './common/SelectStyle.vue'
import FormSection from '../_v2/utils/FormSection.vue'
import CoverSection from './sections/CoverSection.vue'
import ContentSection from './sections/ContentSection.vue'
import AppBarSection from './sections/AppBarSection.vue'
import TicketsSection from './sections/TicketsSection.vue'
import ContactSection from './sections/ContactSection.vue'
import CrmSection from './sections/CrmSection.vue'
import FooterSection from './sections/FooterSection.vue'
import NumbersSection from './sections/NumbersSection.vue'
import CampaignSection from './sections/CampaignSection.vue'
import GallerySection from './sections/GallerySection.vue'
import SpeakersSection from './sections/SpeakersSection.vue'
import SponsorsSection from './sections/SponsorsSection.vue'
import LogosSection from './sections/LogosSection.vue'
import ScheduleSection from './sections/ScheduleSection.vue'
import PersonalizedFaqSection from './sections/PersonalizedFaqSection.vue'
import MaterialsSection from './sections/MaterialsSection.vue'
import TestimonialsSection from './sections/TestimonialsSection.vue'
import FormOthers from "./forms/formsDefault/FormOthers.vue";
import FormIntegrations from "./forms/formsDefault/FormIntegrations.vue";
import FormLayout from "./forms/formsDefault/FormLayout";

export default {
  components: {
    MenuStyles,
    MenuSection,
    MenuOptions,
    MenuPages,
    CurrentSection,
    SelectStyle,
    FormSection,
    CoverSection,
    ContentSection,
    AppBarSection,
    TicketsSection,
    CrmSection,
    ContactSection,
    FooterSection,
    NumbersSection,
    CampaignSection,
    GallerySection,
    SpeakersSection,
    LogosSection,
    SponsorsSection,
    ScheduleSection,
    PersonalizedFaqSection,
    MaterialsSection,
    TestimonialsSection,
    FormLayout,
    FormIntegrations,
    FormOthers
  },

  computed: {
    ...mapGetters(["navbar", "navbar_rerender", "infos", "saveConfig", "tickets", "sectionHover", "editViewType", 'openStyleFromSection']),

    sectionsId() {
      let ids = [];
      this.infos.sections.forEach((section) => {
        ids.push({
          id: "#" + section.id,
          title: section.title ? section.title.content || section.type : section.type,
        });
      });
      return ids;
    },

    isSectionSelected () {
      const nav = this.$store.getters['navbar']
      return nav.open && nav.sectionId === this.sectionId
    }
  },

  data() {
    return {
      types: {
        'style-config': "Estilos",
        menu: "Menu",
        cover: "Capa",
        content: "Conteúdo",
        speakers: "Palestrantes",
        logos: "Logos",
        gallery: "Galeria",
        numbers: "Números",
        schedule: "Programação",
        tickets: "Ingressos",
        testimonials: "Depoimentos",
        newsletter: "Newsletter",
        faq: "Faq",
        contact: "Contato",
        crm: "CRM",
        footer: "Rodapé",
        config: "Configurações",
        campaign: "Cadastro em Campanha",
        sponsors: "Patrocinadores",
        materials: "Materiais",
        personalizedFaq: "Faq",
      },
      selectedSection: null, // null or object
      destination: "Seção",
      isExpanded: {styles: false, pages: true, sections: true, integrations: false, config: false},
    };
  },

  created() {
    this.getSection();
  },

  watch: {
    navbar() {
      this.getSection();
    }
  },

  methods: {
    getSection() {
      if(this.navbar.sectionId === "style-config") {
        this.selectedSection = {
          type: "style-config",
          title: this.infos.title,
          description: this.infos.description,
          layout: this.infos.layout,
          favicon: this.infos.favicon,
          integrations: this.infos.integrations,
        };
      } else {
        this.infos.sections.forEach((section) => {
          if (section.id === this.navbar.sectionId) this.selectedSection = section;
        })

        if (!this.selectedSection) return
      }
    },

    changeDestination() {
      if (this.destination === "Abrir Checkout")
        this.selectedSection.button.action = "Abrir Checkout";
      else this.selectedSection.button.action = "";
    },

    setBackground(type) {
      this.selectedSection["background-type"] = type;
    },

    handleCloseSection() {
      const checkHasUnSavedStyles = this.infos.layout.some(layout => layout.temp === true)
      if (checkHasUnSavedStyles) {
        const confirmAlert = confirm("Estilo ainda não foi criado, deseja voltar mesmo assim?");
        if (confirmAlert === false) return
      }
      
      if (this.openStyleFromSection) {
        this.$store.dispatch("setNav", { open: true, sectionId: this.openStyleFromSection })
        this.$store.dispatch('setOpenStyleFromSection', '')
      } else {
        this.$store.dispatch("setNav", { open: true, sectionId: "" })  
      }
    },

    handleAddSection() {
      this.$store.dispatch("setDialogSection", {open: true, selectedSection: this.sectionId})     
    },

    handleAddStyle() {
      const newId = generateId()
      const newStyle = createUsingSchema(LAYOUT_SCHEMA({id: newId, label: 'Novo estiloX'}))
      newStyle.temp = true
      this.infos.layout.push(newStyle)
      this.$store.dispatch('setLayoutStyle', {open: true, id: newId})
      this.$store.dispatch('setNav', {open: true, sectionId: 'style-config'})
    },

    onCreateNewStyle() {
      this.$store.dispatch("setNav", { open: true, sectionId: "" }) 
      this.isExpanded.styles = true
    },

    handleCancelNewStyle () {
      this.$store.dispatch("setNav", { open: true, sectionId: "" })
    },

    handleAddPage () {
      this.$refs.menuPages.handleAddPage()
    }
   }
};
</script>